import { FC, useCallback, useMemo } from 'react'
import { ISegmentedControlElementProps } from '@cargomart/ui'
import cn from 'classnames'

export const CargoSizeControlDesktopElement: FC<ISegmentedControlElementProps<string>> = ({
  children,
  selected,
  onClick,
  className,
  disabled,
  tabIndex,
  value,
  type = 'button',
  ...rest
}) => {
  const classes = useMemo(() => {
    if (disabled) {
      return cn(
        selected
          ? 'bg-state-on-surface-focused text-on-surface'
          : 'bg-state-on-surface-hover text-on-surface-variant/disabled'
      )
    }

    if (selected) {
      return 'bg-on-primary shadow-3 ring-primary ring-sm'
    }

    return 'text-on-surface bg-surface-variant hover:bg-state-on-surface-variant-hover active:bg-state-on-surface-variant-active'
  }, [disabled, selected])

  const handleClick = useCallback(() => {
    if (value !== undefined && onClick) {
      onClick(value)
    }
  }, [onClick, value])

  return (
    <button
      {...rest}
      aria-disabled={disabled}
      disabled={disabled}
      onClick={handleClick}
      tabIndex={tabIndex}
      // eslint-disable-next-line react/button-has-type
      type={type}
      className={cn(
        className,
        'inline-flex grow appearance-none flex-col items-start justify-between rounded-xl p-3 outline-none transition md:min-h-[11.429em]',
        classes,
        disabled ? 'cursor-not-allowed ' : 'cursor-pointer focus:z-10 focus:ring-sm'
      )}
    >
      {children}
    </button>
  )
}

export default CargoSizeControlDesktopElement
